import { _ } from "../../../core/polyglot/polyglot.js";
import { create } from "../../../core/helpers/pdf-util.js";
import AbstractReportExporter from "./AbstractReportExporter.js";
import PdfExportingVisitor from "../visitors/exporters/PdfExportingVisitor.js";

/**
 * TODO: write documentation
 */
export default class PdfExporter extends AbstractReportExporter {
	simpleLabel() {
		return _("PDF");
	}

	_exportingVisitorClass() {
		return PdfExportingVisitor;
	}

	_downloadData({ data, filename }) {
		create(data)
			.download(filename)
			.catch(() => {});
	}

	_prepareAssets({ exportingVisitor, report }) {
		return exportingVisitor.prepareAssets(report);
	}

	_filenameExtension() {
		return "pdf";
	}
}
